<template>
  <div class="nav-wrapper">
    <div class="nav-text">
      <span class="first-title">{{firstTitle}}</span>
      <span v-if="secondTitle">></span>
      <span class="second-title">{{secondTitle}}</span>
    </div>
    <div class="nav-right">
      <nav-search></nav-search>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import navSearch from "@/components/common/search.vue";
export default {
  components: {
    navSearch
  },
  computed: {
    ...mapGetters(["firstTitle",'secondTitle'])
  },
};
</script>

<style lang="less" scoped>
@import "../../common/minix.less";
.nav-wrapper {
  font-size: 24 / @rem;
  width: 100%;
  padding: 0 20 / @rem;
  box-sizing: border-box;
  height: 100 / @rem;
  background: #dbe0ea;
  display: flex;
  flex-direction: row;
  align-items: center;
  .nav-text {
    flex: 1;
    font-size: 0;
    color: #222;
    span {
      font-size: 28 / @rem;
    }
    .first-title {
      color: #284faa;
    }
  }
  .nav-right {
    width: 50 / @rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/nav.vue